<app-form-input 
[parentForm]="parentForm" 
[value]="fourchette?.valeurBasse" 
[disabled]="disabled"
[label]="step3.valeurBasse"
[type]="'number'" [rule]="'digits_2'"
[name]="getUid()+'_SepAtt_valeurBasse'">
</app-form-input>

<!---->

<app-form-input 
[parentForm]="parentForm" 
[value]="fourchette?.valeurHaute" 
[disabled]="disabled"
[label]="step3.valeurHaute"
[type]="'number'" [rule]="'digits_2'"
[name]="getUid()+'_SepAtt_valeurHaute'">
</app-form-input>